import { Box, Button, Input, Stack } from '@vouched.id/vault';
import React, { useCallback, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Dropdown } from '../Dropdown';
import { setMessages } from 'store/actions/actions';
import { useGlobalState } from 'store/reducers/reducer';
import { removeJob } from 'store/sagas/sagas';
export const DeleteDropdown = () => {
    const { asyncDispatch, dispatch } = useGlobalState();
    const navigate = useNavigate();
    const { id: jobSid } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [inputJobSid, setInputJobSid] = useState('');
    const [isInvalidInput, setIsInvalidInput] = useState(false);
    const handleRemove = useCallback((sid) => {
        asyncDispatch(removeJob(sid))
            .then(() => {
            dispatch(setMessages({
                value: `Deleted job ${sid}`,
                severity: 'success'
            }));
            navigate('/account/jobs', { replace: true });
        })
            .catch(() => {
            dispatch(setMessages({
                value: `Unable to delete job ${sid}`,
                severity: 'error'
            }));
            setIsLoading(false);
        });
    }, [asyncDispatch, dispatch]);
    const handleChange = useCallback((e) => {
        const { value } = e.target;
        setInputJobSid(value);
        if (value === jobSid || value === '')
            setIsInvalidInput(false);
    }, []);
    const handleBlur = useCallback((e) => {
        setIsInvalidInput(e.target.value !== jobSid);
    }, []);
    const submit = (event) => {
        event.preventDefault();
        if (isLoading) {
            return;
        }
        if (inputJobSid) {
            if (inputJobSid !== jobSid) {
                setIsInvalidInput(true);
                return;
            }
            setIsLoading(true);
            handleRemove(jobSid);
        }
    };
    return (React.createElement(Dropdown, { title: "Delete" },
        React.createElement("p", null,
            "Warning! Once deleted, this job will be gone forever. Type in this job's ID, ",
            jobSid,
            ", to delete it."),
        React.createElement(Box, { maxWidth: "52rem", noValidate: true, onSubmit: submit, tag: "form", width: "100%" },
            React.createElement(Stack, { spacing: "spacing.large" },
                React.createElement(Box, null,
                    React.createElement(Input, { autoComplete: "off", inputMode: "text", isInvalid: isInvalidInput, label: "Job ID", name: "Job ID", onBlur: handleBlur, onChange: handleChange, required: true, validationMessage: "Job ID's do not match" })),
                React.createElement(Box, { alignItems: "center", display: "flex", justifyContent: "center", marginTop: "spacing.default", paddingTop: "spacing.default", width: "100%" },
                    React.createElement(Button, { "data-cy": "submit", title: isLoading ? 'loading' : '' }, "Delete"))))));
};
